import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import 'core-js/features/string/repeat';
import 'abortcontroller-polyfill';

import 'regenerator-runtime/runtime';
import './scss/App.scss';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/reducers/configureStore';
import App from './App';
import {unregister} from './registerServiceWorker';
import configureAxios from './utilities/configureAxios';
import { Spinner } from './controls/spinner/SpinnerRoot';

import './i18n';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

// configuring axios 
const { dispatch } = store; 
configureAxios(dispatch);

const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
        <ConnectedRouter history={history}>
            <Suspense fallback={<Spinner/>}>
                <App />
            </Suspense>
    </ConnectedRouter>
  </Provider>,
  rootElement);

//unregister the service worker we are not going to use the service worker until we can figure out the reason the service worker is unable to update. 
unregister()
//registerServiceWorker();